// extracted by mini-css-extract-plugin
export default {"MarketPlace":"marketplace_MarketPlace__kn3eU","Market":"marketplace_Market__h2wxR"};